import { OccType, PriceChannel, PriceType, SourceChannelType } from '@/config';
import actionType from '../actions/price/actionType';
import { Channel, Strategy } from './channel';

interface Price {
  price: number | string; // 单位分
  priceType: PriceType;
  rate: number; // 折扣率
  disCountPrice: number;
  discount: number;
  estimationPrice: number; // 预估底价
  everyDaySpecialPrice: number; // 美团直连天天特价
  otaBillType: string; // MT_ZL 美团直连
}

export type PriceItem = Channel &
  Strategy &
  Price & { id?: any; uniqueId: string; isSaveFailed?: boolean; roomViewName?: string };

interface PriceGeneralInfo {
  currentDay: string; // 格式yyyy-MM-dd
  currentMonth: string; // 格式yyyy-MM
  deposit: number;
  id: number;
  overtimePrice: number; // 超时一小时单价，单位分
  roomTypeId: number;
  roomTypeName: string;
  shopName: string;
}

interface PriceEdit {
  dayDate: string;
  edit: boolean;
  executeType: 1 | 2; // 执行策略类型：1-基础价，2-日历特殊价格
  marketPrice: number;
  memberPrice: number;
  status: 1 | 2; // 1-正常，2-特殊
}

// 标准价
export type DayPriceItem = PriceEdit & {
  dayPriceList: Array<PriceItem>;
  tempPriceList: Array<PriceItem>;
};

// 基础价、特殊价
interface PeriodDay {
  basePrice: number | string;
  periodDay: string;
  periodType: 1 | 2 | 3; // 1-日循环、2-周循环、3-月循环
}
export type BaseSpecialPriceItem = PriceItem & {
  basePricePeriods: Array<PeriodDay>;
};

// 折扣价
export interface DiscountPrice {
  marketDiscount: number; // 门市价折扣
  marketDiscountPrice: number; // 中央预订门市打折房价
  marketOriPrice: number; // 中央预订门市原房价
  memberDiscount: number; // 会员价折扣
  memberDiscountPrice: number; // 中央预订会员打折房价
  memberOriPrice: number; // 中央预订会员原房价
  occDuration: number; // 入住时长
  occType: OccType;
  roomTypeId: number;
  roomTypeName: string;
  roomTypeViewName: string; // 展示房型名称
}

export interface DiscountDetail {
  id: string;
  channelId: number;
  channelType: SourceChannelType;
  channelName: string;
  priceChannel: PriceChannel;
  priceType: PriceType;
  strategyId: number;
  strategyPrice?: number;
  strategyName: string;
  discount: number;
  oriPrice: number;
  discountPrice: number;
  occDuration: number;
  occType: OccType;
  isSaveFailed?: boolean;
}

export interface PriceInitialState {
  priceGeneralInfo: Partial<PriceGeneralInfo>;
  datePriceMap: { [key: string]: Partial<DayPriceItem> };
  dayBasePriceList: Array<BaseSpecialPriceItem>;
  tempBasePriceList: Array<BaseSpecialPriceItem>;
  daySpecialPriceList: Array<PriceItem>;
  tempSpecialPriceList: Array<PriceItem>;
  dayDynamicColumnsMap: Object;
  dayTargetSourceList: Array<any>;
  hourDynamicColumnsMap: Object;
  hourTargetSourceList: Array<any>;
  minDiscount: number;
  discountDayList: Array<string>;
  priceLoading: boolean;
  basePriceLoading: boolean;
  specialPriceLoading: boolean;
  hotelDisountPriceLoading: boolean;
  updateHotelDisountPriceLoading: boolean;
}

const initialState: PriceInitialState = {
  // 概要信息
  priceGeneralInfo: {},
  // 日历价格map
  datePriceMap: {},
  // 基础价
  dayBasePriceList: [],
  tempBasePriceList: [],
  // 特殊价
  daySpecialPriceList: [],
  tempSpecialPriceList: [],
  // 折扣价
  dayDynamicColumnsMap: [],
  dayTargetSourceList: [],
  hourDynamicColumnsMap: [],
  hourTargetSourceList: [],
  // 打折配置
  minDiscount: undefined,
  discountDayList: [],
  priceLoading: false,
  basePriceLoading: false,
  specialPriceLoading: false,
  hotelDisountPriceLoading: false,
  updateHotelDisountPriceLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.TOGGLE_LOADING: {
      const loading = state[action.payload];
      return {
        ...state,
        [action.payload]: !loading,
      };
    }
    case actionType.UPDATE_STATE:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.PRICE_MAP:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.BASE_PRICE_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SPECIAL_PRICE_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.UPDATE_BASE_PRICE:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.UPDATE_SPECIAL_PRICE:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.HOTEL_DISCOUNT_PRICE_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.HOTEL_DISCOUNT_CONFIG:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
